module.exports = __webpack_public_path__ + "img/wechat.cc53dbd2.png";